@if (!item().hidden) {
  @if (item().url && !item().external) {
    <li [ngClass]="item().classes!" [routerLinkActive]="['active']">
      <a
        class="nav-link"
        [target]="item().target ? '_blank' : '_self'"
        [routerLink]="[item().url]"
        (click)="toggleMenu($event)"
        [routerLinkActive]="['active']"
      >
        @if (item().icon) {
          <span class="coded-micon">
            <i class="{{ item().icon }}"></i>
          </span>
          <span class="coded-mtext">{{ item().title | translate }}</span>
        } @else {
          {{ item().title | translate }}
        }
      </a>
    </li>
  } @else if (item().url && item().external) {
    <li [ngClass]="item().classes!">
      <a [target]="item().target ? '_blank' : '_self'" [href]="item().url">
        @if (item().icon) {
          <span class="coded-micon">
            <i class="{{ item().icon }}"></i>
          </span>
          <span class="coded-mtext">{{ item().title | translate }}</span>
        } @else {
          {{ item().title | translate }}
        }
      </a>
    </li>
  }
}
